export enum ThreadFilterValue {
  FILTER_ALL = "all",
  FILTER_USER_UNANSWERED = "user_unanswered",
  FILTER_USER_ACCEPTED = "user_accepted",
  FILTER_USER_DECLINED = "user_declined"
}
